import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer } from '@bos/ui';
import { SectionHeader } from '../primitives/SectionHeader';
export const MobilitySection = ({ title, children, tooltipText, }) => {
    return (_jsxs(FlexContainer, { direction: 'column', gap: '2', children: [_jsx(SectionHeader, { title: title, variant: 'h5', tooltipText: tooltipText }), children] }));
};
